import * as React from 'react';
import { AccentButton } from '../AccentButton';
import { ConfiguratorContext } from './ConfigContextProvider';
import { getOptionModel, isReadOnly, setOptionValueChanged } from './ProductConfiguratorShared';

// Renders a checkbox option marked with the SWF.MomentaryButton custom display type as a
// one-shot command button (e.g. the SWF vendor's "Clear All Color Related Fields"). The
// underlying value is pulsed true -> false so the engine sees a fresh transition on every
// press and the command never persists a state on the order line. UserChanged is not set:
// the option is a command, not a user-held value.
export const ConfigActionButton = props => {

    const ctx = React.useContext(ConfiguratorContext);
    const optionModel = getOptionModel(ctx, props.optionID);

    const readOnly = isReadOnly(optionModel);

    const onClick = React.useCallback(() => {

        optionModel.SetValue(window.InsyteConfig.OptionModelSetValueArgs.From(null, "true"));
        setOptionValueChanged(ctx, optionModel, undefined, false);

        // Re-arm for the next press. The engine has already acted on the "true" run; this
        // second run only writes the unchecked state back.
        optionModel.SetValue(window.InsyteConfig.OptionModelSetValueArgs.From(null, "false"));
        setOptionValueChanged(ctx, optionModel, undefined, false);

    }, [ctx, optionModel]);

    return <div className="config-control config-action-button">
        <AccentButton tagName={`action_${props.optionID}`} disabled={readOnly} onClick={onClick}>
            {optionModel.Label}
        </AccentButton>
    </div>;
};
